import React from "react";
import { useTranslation } from "react-i18next";
import AppLayoutAssistant from "../../../navigation/Layout/LayoutAssistant";
import PaymentBoard from "../../components/PaymentBoard/PaymentBoard";
import { DOCTOR_PLANS } from "../../config/plans.config";

export default function PlansAssistant() {
  const { t } = useTranslation();
  const assistantId = localStorage.getItem("assistantId") || null;

  return (
    <AppLayoutAssistant>
      <PaymentBoard
        plans={DOCTOR_PLANS}
        userId={assistantId}
        userType="assistant"
        title={t("payment.pages.assistant.title")}
        subtitle={t("payment.pages.assistant.subtitle")}
      />
    </AppLayoutAssistant>
  );
}